export default __webpack_public_path__ + "static/media/download-blue.93d6fc71.svg";